export default function StreamProjection() {
  return (
    <div className="fit-screen">
      <div className="container">
        <h1>Projetor Live</h1>
      </div>
    </div>
  );
}
